import React from "react";
import PropTypes from "prop-types";
import "./table-component.css";
import increaseIcon from "../../assets/SVGs/increase.svg";
import decreaseIcon from "../../assets/SVGs/decrease.svg";
const DashboardInvestmentTableComponent = ({ headers, data, theme }) => {
  const calculateTotalGainLoss = (CurrentPrice, PurchasePrice, shares) => {
    CurrentPrice = parseFloat(CurrentPrice) || 0;
    PurchasePrice = parseFloat(PurchasePrice) || 0;
    shares = parseFloat(shares) || 0;
    let gainLoss = CurrentPrice - PurchasePrice;
    let gainLossPercentage =
      ((CurrentPrice - PurchasePrice) / PurchasePrice) * 100;
    return {
      totalGainLoss: gainLoss ? gainLoss.toFixed(2) : 0,
      gainLossPercentage: gainLossPercentage
        ? gainLossPercentage.toFixed(2)
        : 0,
    };
  };
  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "#232323" : "white",
      }}
      className="main-dashboad-table-container"
    >
      <div className="table-wrapper" style={{ paddingInline: "20px" }}>
        <table className="custom-table">
          <thead
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
          >
            <tr
              style={{
                fontWeight: "700",
              }}
            >
              {headers.map((header, index) => (
                <th
                  style={{
                    fontWeight: "700",
                    color: theme === "dark" ? "#ffffff" : "#232323",
                    backgroundColor: theme === "dark" ? "#232323" : "#ffffff",
                  }}
                  key={index}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
          >
            {data.map((row, rowIndex) => {
              let result = calculateTotalGainLoss(
                row.approximateMarketValue && row.shares
                  ? parseFloat(row.approximateMarketValue) /
                      parseFloat(row.shares)
                  : row.dayChange,
                row.averageCost ? row.averageCost : row.approximateMarketValue,
                row.shares
              );
              return (
                <tr key={rowIndex}>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    {row.name || "N/A"}
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    {row.tickerSymbol || "N/A"}
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    {(row.pricePerShare && `$${row.pricePerShare}`) || "N/A"}
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    {result && result.totalGainLoss ? (
                      <div>{result.totalGainLoss}</div>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    {result && result.gainLossPercentage ? (
                      <div>{result.gainLossPercentage}%</div>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    {result &&
                    result.totalGainLoss &&
                    result.totalGainLoss > 0 ? (
                      <img src={increaseIcon} alt="increaseIcon" />
                    ) : (
                      <img src={decreaseIcon} alt="increaseIcon" />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardInvestmentTableComponent;
